import * as React from 'react';

type IPhoneHangUpProps = React.SVGProps<SVGSVGElement>;

export function PhoneHangUp(props: IPhoneHangUpProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 -4 14 14">
      <g fill="none" fillRule="evenodd">
        <path d="M0-5h14V9H0z" />
        <path
          fill="#2B87DB"
          d="M7 1.129c-.933 0-1.838.14-2.683.406v1.75c0 .22-.135.417-.327.507a6.723 6.723 0 0 0-1.552 1.044.583.583 0 0 1-.408.158.592.592 0 0 1-.414-.163L.169 3.43a.553.553 0 0 1 0-.796A10.08 10.08 0 0 1 7 0a10.08 10.08 0 0 1 6.83 2.635c.106.102.17.243.17.401 0 .158-.064.3-.17.4l-1.446 1.4a.61.61 0 0 1-.822.006 6.584 6.584 0 0 0-1.558-1.044.56.56 0 0 1-.326-.508V1.54A8.728 8.728 0 0 0 7 1.13z"
        />
      </g>
    </svg>
  );
}
